import { Grid, Tooltip } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';
import { CommonCivilStatusFormVM } from 'civil-status/view-models/document-birth-form';
import { PageMode } from 'civil-status/view-models/page-mode';
import { authsObject } from 'civil-status/components/shared/buttons';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { useBus } from 'shell/hooks/use-bus';

export const DeleteAllEvent = 'DeleteAllAnnotationEvent';

interface DocumentVisualizationsButtonsProps {
  onBack: () => void;
  onChange: (
    key: keyof CommonCivilStatusFormVM,
    value: CommonCivilStatusFormVM[keyof CommonCivilStatusFormVM]
  ) => void;
  setMode: (mode: PageMode) => void;
  type: string;
  values: CommonCivilStatusFormVM;
  mode: PageMode;
  handleSubmit: () => void;
}

const DocumentVisualizationsButtonsComponent = ({
  onBack,
  setMode,
  mode,
  handleSubmit,
}: DocumentVisualizationsButtonsProps): React.ReactElement => {
  const auths = useActionAuthorization(authsObject);

  const bus = useBus();

  return (
    <>
      {mode === PageMode.Edit ? (
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12} md={6}>
            <PmiButton
              variant="outlined"
              color="cdmBrandThird"
              fullWidth
              onClick={() => handleSubmit()}
            >
              Salva
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiButton
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                setMode(PageMode.Detail);
              }}
            >
              Indietro
            </PmiButton>
          </Grid>
        </Grid>
      ) : undefined}
      {mode === PageMode.Detail ? (
        <>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={12} md={4}>
              <PmiButton variant="outlined" color="secondary" fullWidth onClick={onBack}>
                Indietro
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiButton
                variant="outlined"
                color="cdmBrandThird"
                fullWidth
                onClick={() => {
                  handleSubmit();
                }}
              >
                Avanti
              </PmiButton>
            </Grid>
          </Grid>

          <Grid item container xs={12} spacing={2}>
            <Grid item xs={12} md={3}>
              <Tooltip
                arrow
                title={
                  auths.edit ? '' : "Non si ha l'autorizzazione per accedere a questa funzionalità"
                }
              >
                <span>
                  <PmiButton
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setMode(PageMode.Edit);
                    }}
                  >
                    Modifica
                  </PmiButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={4}>
              <Tooltip
                arrow
                title={
                  auths.annotation
                    ? ''
                    : "Non si ha l'autorizzazione per accedere a questa funzionalità"
                }
              >
                <span>
                  <PmiButton
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    disabled={!auths.annotation}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setMode(PageMode.National);
                    }}
                  >
                    Annotazioni Italia
                  </PmiButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={5}>
              <Tooltip
                arrow
                title={
                  auths.annotation
                    ? ''
                    : "Non si ha l'autorizzazione per accedere a questa funzionalità"
                }
              >
                <span>
                  <PmiButton
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    disabled={!auths.annotation}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setMode(PageMode.International);
                    }}
                  >
                    Annotazioni Internazionali
                  </PmiButton>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </>
      ) : undefined}
      {mode === PageMode.International ? (
        <>
          <Grid item container spacing={2} xs={12}>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="contained"
                color="cdmBrand"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  bus.emit(DeleteAllEvent);
                }}
              >
                Elimina tutte
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  setMode(PageMode.Detail);
                }}
              >
                Indietro
              </PmiButton>
            </Grid>
          </Grid>
        </>
      ) : undefined}
      {mode === PageMode.National ? (
        <>
          <Grid item container spacing={2} xs={12}>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="contained"
                color="cdmBrand"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  bus.emit(DeleteAllEvent);
                }}
              >
                Elimina Tutte
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  setMode(PageMode.Detail);
                }}
              >
                Indietro
              </PmiButton>
            </Grid>
          </Grid>
        </>
      ) : undefined}
    </>
  );
};

DocumentVisualizationsButtonsComponent.displayName = 'Document Buttons form component';

const DocumentVisualizationsButtonsForm = memo(DocumentVisualizationsButtonsComponent);

export default DocumentVisualizationsButtonsForm;
